module.exports = __webpack_public_path__ + "assets/retina_LTangentDetailed.4d97640f4eaeb72f1652be7e3393d671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LTangentDetailed.png
// module id = 688
// module chunks = 0